var map = {
	"./1.gif": 295,
	"./10.gif": 296,
	"./2.gif": 297,
	"./3.gif": 298,
	"./4.gif": 299,
	"./5.gif": 300,
	"./6.gif": 301,
	"./7.gif": 302,
	"./8.gif": 303,
	"./9.gif": 304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 294;